import React, { useState } from "react";
import { Avatar, Dropdown, message, Modal } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import ButtonBase from "../Button";
import { useLogoutMutation } from "../../store/Auth/Logout";
import { useTranslation } from "react-i18next";
import { renderConfigApp } from "../../constants/ultil";

const HeaderBar = ({ listConfig }) => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.auth.authInfo);
  const [isConfirmLogout, setIsConfirmLogout] = useState(false);
  const [logout, { isLoading }] = useLogoutMutation();

  const onHandleLogout = async () => {
    try {
      await logout();
      Cookies.remove("accessToken");
      setIsConfirmLogout(false);
    } catch (error) {
      message.error(error?.data?.message);
    }
  };

  const menuItems = [
    {
      key: "logout",
      label: t("auth.logout"),
      icon: <LogoutOutlined />,
      onClick: () => setIsConfirmLogout(true),
    },
  ];
  return (
    <>
      <img
        src={renderConfigApp(listConfig?.data, "vi", "site_logo")}
        width={161}
        alt="logo"
      />
      <div className="flex items-center">
        <div className="mr-4 font-medium text-[13px]">
          <div className="mb-2 text-end">{userInfo?.name}</div>
          <div>{userInfo?.email}</div>
        </div>
        <div className="cursor-pointer">
          <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
            <Avatar size={40} icon={<UserOutlined />} />
          </Dropdown>
        </div>
      </div>
      <Modal
        open={isConfirmLogout}
        onCancel={() => setIsConfirmLogout(false)}
        footer={false}
      >
        <div className="text-center p-3">{t("auth.confirmLogout")}</div>
        <div className="text-center mt-4">
          <ButtonBase
            title={t("auth.cancel")}
            className="mr-3 !bg-white !text-[#333333]"
            onClick={() => setIsConfirmLogout(false)}
          />
          <ButtonBase
            title={t("auth.logout")}
            onClick={onHandleLogout}
            loading={isLoading}
          />
        </div>
      </Modal>
    </>
  );
};

export default HeaderBar;
